// تحویل گیرندگان خودرو
import React, { useState, useEffect } from 'react';
import ListPage, { ui } from '../../components/ListPage';
import { usePagedList, CountBadge } from '../../components/paging';
import { ExcelButton } from '../../components/excel';
import { useFormButtons } from '../../utils/vbPerms';
import { API, qs, Grid, Field, TextIn, DateIn, Lookup, Modal, DeleteDialog, MsgDialog, excelCols } from './carsShared';

const BUTTONS = ['BTNNEW', 'BTNEDIT', 'BTNDELETE', 'BTNOK', 'BTNCANCEL'];
const blank = () => ({ event_date: '', kilometer: '', people: { id: 0, title: '' }, department: { id: 0, title: '' } });

export default function CarTransferee({ user, onBack, carId, carTitle = '' }) {
  const fb = useFormButtons('FRMCARTRANSFEREE', BUTTONS);
  const [cols, setCols] = useState([]);
  const [sel, setSel] = useState(null);
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState(blank());
  const [err, setErr] = useState('');
  const [msg, setMsg] = useState('');

  const L = usePagedList((page) => API(`/transferee/?${qs({ page, car_id: carId })}`)
    .then(j => { if (j.ok && page === 1) setCols(j.columns || []); return j; }));
  const reload = () => L.reload({});
  useEffect(() => { if (fb.open) reload(); }, [fb.open]);

  const F = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const save = async () => {
    setErr('');
    const body = JSON.stringify({ car_id: carId, event_date: form.event_date, kilometer: form.kilometer,
      people_id: form.people.id, department_id: form.department.id });
    const j = modal === 'new'
      ? await API('/transferee/create/', { method: 'POST', body })
      : await API(`/transferee/${sel.CarTransfereeId}/update/`, { method: 'PUT', body });
    if (j.info) setMsg(j.info);
    if (!j.ok) { setErr(j.msg); return; }
    setModal(null); reload();
  };
  const doDelete = async () => {
    setModal(null);
    const j = await API(`/transferee/${sel.CarTransfereeId}/delete/`, { method: 'DELETE' });
    if (!j.ok) setMsg(j.msg); else { setSel(null); reload(); }
  };
  const has = !!sel;

  const toolbar = fb.open ? (
    <>
      <div style={ui.toolBtns}>
        {fb.can('BTNNEW') && <button onClick={() => { setForm(blank()); setErr(''); setModal('new'); }} style={ui.btnNew}>＋ جدید</button>}
        {fb.can('BTNEDIT') && <button disabled={!has} onClick={() => {
          setForm({ event_date: sel['تاریخ'] || '', kilometer: sel['کیلومتر'] ?? '', people: { id: sel.PeopleId || 0, title: sel['تحویل گیرنده'] || '' },
            department: { id: sel.DepartmentId || 0, title: sel['واحد اجرایی'] || '' } });
          setErr(''); setModal('edit');
        }} style={{ ...ui.btnEdit, opacity: has ? 1 : 0.4 }}>✎ ویرایش</button>}
        {fb.can('BTNDELETE') && <button disabled={!has} onClick={() => setModal('delete')} style={{ ...ui.btnDel, opacity: has ? 1 : 0.4 }}>✕ حذف</button>}
      </div>
      <CountBadge shown={L.data.length} total={L.pager.total} loading={L.loading} unit="ردیف" />
      <ExcelButton title="تحویل گیرندگان خودرو" subtitle={carTitle} columns={excelCols(cols, L.data)} rows={L.data} />
    </>
  ) : null;

  return (
    <>
      <ListPage user={user} onBack={onBack} title={`تحویل گیرندگان خودرو ${carTitle}`} subtitle="تدارکات — سامانه ارجان"
        toolbar={toolbar} error={L.error} pager={L.pager} onMore={L.more} loading={L.loading}>
        <Grid columns={cols} rows={L.data} rowKey="CarTransfereeId" selectedKey={sel?.CarTransfereeId} onSelect={setSel} />
      </ListPage>
      {(modal === 'new' || modal === 'edit') && (
        <Modal title={modal === 'new' ? '＋ تحویل گیرنده جدید' : '✎ ویرایش تحویل گیرنده'} onClose={() => setModal(null)} width="640px"
          footer={<>
            <button onClick={() => setModal(null)} style={ui.btnCancel}>لغو</button>
            {fb.can('BTNOK') && fb.can(modal === 'new' ? 'BTNNEW' : 'BTNEDIT') && <button onClick={save} style={ui.btnSave}>ثبت</button>}
          </>}>
          {err && <div style={ui.errBox}>⚠️ {err}</div>}
          <div style={ui.row}>
            <Field label="تاریخ"><DateIn value={form.event_date} onChange={v => F('event_date', v)} /></Field>
            <Field label="کیلومتر"><TextIn num value={form.kilometer} onChange={v => F('kilometer', v)} /></Field>
          </div>
          <div style={ui.row}>
            <Field label="تحویل گیرنده"><Lookup path="/transferee/lookup/people/" value={form.people} onChange={v => F('people', v)} /></Field>
            <Field label="واحد استفاده کننده"><Lookup path="/transferee/lookup/department/" value={form.department} onChange={v => F('department', v)} /></Field>
          </div>
        </Modal>
      )}
      {modal === 'delete' && <DeleteDialog onConfirm={doDelete} onCancel={() => setModal(null)} />}
      {msg && <MsgDialog text={msg} onClose={() => setMsg('')} />}
    </>
  );
}
